let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kvzBD")).then(() => parcelRequire('5Qre5'));